<template>
    <div>
        <b-row>
            <b-col sm="6">
                <b-form-group>
                    <b-input-group>
                        <b-form-input name="search" v-model="filterText" type="text" placeholder="Buscar..." />
                        <b-input-group-append>
                            <b-button @click="clearFilter" class="ml-2 btn-clear">
                                <i class="fa fa-eraser fa-lg" />
                                <span class="d-none d-md-inline-block"> Limpiar</span>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

            </b-col>

            <b-col class="mb-2" sm="6">
                <b-dropdown v-if="validarPermisoComponente('empresa-editar-areas')" id="options" variant="primary"
                    text="Opciones" class="float-right" :disabled="!params.company_id">
                    <b-dropdown-item @click="openModalForCreation()">
                        <i class="fa fa-plus" /> Crear
                    </b-dropdown-item>
                    <b-dropdown-item @click="downloadTemplate">
                        <i class="fa fa-download" /> Descargar plantilla
                    </b-dropdown-item>
                    <b-dropdown-item @click="setShowToModalUpload(true)">
                        <i class="fa fa-upload" /> Carga masiva
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>

        <div class="tree-section">
            <div class="scroll-container">
                <el-tree class="area-tree custom-tree" :data="areasTree" :props="defaultProps" default-expand-all
                    :filter-node-method="filterNode" ref="tree">
                    <template #default="{ node }">
                        <div class="custom-tree-node">
                            <div class="node-content">
                                <b-badge :class="['me-2', { 'parent-badge': node.childNodes.length > 0 }]">
                                    {{ node.data.code }}
                                </b-badge>
                                <span class="mr-2 ml-1 node-name">{{ node.data.name }}</span>
                                <div class="d-inline-block ms-2">
                                    <b-button v-if="validarPermisoComponente('empresa-editar-areas')" variant="link"
                                        size="sm" class="ml-2 p-0 text-primary"
                                        @click.stop="openModalForEdition(node.data)" v-b-tooltip.hover title="Editar">
                                        <i class="fa fa-edit"></i>
                                    </b-button>
                                    <b-button v-if="validarPermisoComponente('empresa-editar-areas')" variant="link"
                                        size="sm" class="ml-2 p-0 text-danger ms-1"
                                        @click.stop="areaDelete(node.data.id)" v-b-tooltip.hover title="Eliminar">
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-tree>
            </div>
        </div>

        <modal />
        <modal_upload />
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import modal from './modal.vue';
import modal_upload from './modal_upload.vue';
import { validarPermisoComponente } from "@/plugins/acl";

export default {
    name: 'AreaTree',
    components: {
        modal,
        modal_upload
    },
    data() {
        return {
            company_id: this.$route.params.id,
            validarPermisoComponente: validarPermisoComponente,
            defaultProps: {
                children: "children",
                label: "name"
            },
            filterText: "",
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
    computed: {
        ...mapState('areas', [
            'areas',
            'params',
            'companies',
            'areasTree',
        ])
    },
    created() {
        this.resetParams();
        this.params.company_id = this.company_id;
        this.fetchAreasTree(this.company_id);
        this.load(false);
    },
    methods: {
        ...mapActions('areas', [
            'fetchCompanies',
            'fetchAreas',
            'getArea',
            'deleteArea',
            'getLastArea',
            'downloadTemplate',
            'showAreaFather',
            'fetchAreasTree',
        ]),
        ...mapMutations('areas', [
            'setModalShow',
            'resetParams',
            'setEditing',
            'resetArea',
            'setShowToModalUpload'
        ]),
        ...mapMutations('dashboard', ['load']),
        async openModalForCreation() {
            this.resetArea();
            await this.getLastArea();
            await this.showAreaFather({ company_id: this.company_id });
            this.setEditing(false);
            this.setModalShow(true);
        },
        async openModalForEdition(area) {
            await this.getArea(area.id);
            await this.showAreaFather({ company_id: this.company_id, id: area.id });
            this.setEditing(true);
            this.setModalShow(true);
        },
        async resetParamsFilter() {
            this.resetParams();
            this.params.company_id = this.company_id;
            await this.fetchAreas(true);
        },
        clearFilter() {
            this.filterText = "";
            this.fetchAreasTree(this.company_id);
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.name.toLowerCase().includes(value.toLowerCase());
        },
        async areaDelete(id) {
            const res = await this.deleteArea(id);
            if (res) {
                this.fetchAreasTree(this.company_id);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.area-tree-container {
    .controls-section {
        .search-box {
            :deep(.el-input__inner) {
                border-radius: 4px;
            }
        }
    }

    .tree-section {
        .area-tree {
            max-height: calc(100vh - 300px);
            overflow-y: auto;
        }
    }
}

:deep(.custom-tree) {
    .el-tree-node {
        position: relative;
        padding-left: 24px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 1px;
            height: 100%;
            border-left: 2px dotted #97a0af;
        }

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 20px;
            width: 24px;
            height: 2px;
            border-top: 2px dotted #97a0af;
        }

        &:last-child::before {
            height: 20px;
        }
    }

    .el-tree-node__content {
        padding: 8px 0;
        height: auto !important;
    }

    .custom-tree-node {
        width: 100%;

        .node-content {
            display: flex;
            align-items: center;

            .badge {
                background-color: #c8ced3;
                color: white;
                font-weight: 500;
                padding: 0.5em 0.7em;
            }

            .parent-badge {
                background-color: #2cb7c6;
            }

            .node-name {
                font-weight: 500;
                text-transform: uppercase;
            }

            .node-actions {
                opacity: 0;
                transition: opacity 0.2s;

                .btn-link {
                    padding: 0 4px;

                    i {
                        font-size: 16px;
                    }
                }
            }

            &:hover .node-actions {
                opacity: 1;
            }
        }
    }
}

.area-tree {
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #2cb7c5;
        border-radius: 4px;

        &:hover {
            background: darken(#2cb7c5, 10%);
        }
    }
}

.tree-section .scroll-container {
    max-height: calc(100vh - 300px);
    overflow-x: auto;
    overflow-y: auto;
    white-space: nowrap;
    padding: 8px 16px 16px 8px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
}

.custom-tree-node {
    display: inline-block;
    white-space: nowrap;
    width: auto;
}

.el-tree {
    display: inline-block;
    width: auto;
    min-width: 100%;
}

.el-tree-node__content {
    display: inline-block;
    white-space: nowrap;
    width: auto;
}

.scroll-container::-webkit-scrollbar {
    height: 8px;
    width: 8px;
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #2cb7c5;
    border-radius: 4px;
}

.scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.fa-trash {
    font-size: 20px;
}

.fa-edit {
    font-size: 20px;
}
</style>
